<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SvgCluster',
  props: {
    spin: {
      type: Boolean,
      default: true,
    },
  },
});
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="currentColor">
    <g>
      <path
        id="clusterInner"
        :class="{ spin }"
        d="M53.98,59.96c-1.55-3.73-5.83-5.49-9.55-3.94-3.73,1.55-5.49,5.83-3.94,9.55,1.55,3.73,5.83,5.49,9.55,3.94,0,0,0,0,0,0,2.2-.91,3.81-2.84,4.32-5.17,7.31-2.42,11.26-10.3,8.85-17.61-.17-.52-.37-1.02-.61-1.52-.47-.96-1.63-1.36-2.59-.89,0,0,0,0,0,0-.94,.46-1.34,1.58-.92,2.53,2.35,5.04,.17,11.03-4.87,13.39-.04,.02-.09,.04-.14,.06-.04-.12-.08-.23-.12-.35h.03Zm-3.55,4.05c-.69,1.7-2.63,2.53-4.33,1.84,0,0,0,0,0,0-1.7-.69-2.53-2.63-1.84-4.33,0,0,0,0,0,0,.69-1.7,2.63-2.53,4.33-1.84,0,0,0,0,0,0,.82,.33,1.47,.98,1.82,1.79s.36,1.73,.02,2.55Zm-4.88-27.18c-.16,.39-.29,.79-.37,1.21-7.22,2.67-10.91,10.69-8.23,17.9,.05,.13,.11,.28,.16,.41,.4,.99,1.53,1.46,2.52,1.06,.99-.4,1.46-1.53,1.06-2.52-1.97-4.85,.11-10.4,4.79-12.76,.04,.09,.06,.19,.1,.28,1.55,3.67,5.78,5.38,9.45,3.83,3.67-1.55,5.38-5.78,3.83-9.45-.75-1.76-2.16-3.16-3.94-3.88-3.66-1.51-7.85,.24-9.35,3.9,0,0,0,0,0,.01Zm9.72,1.47c.72,1.68-.06,3.64-1.75,4.36,0,0-.02,0-.04,0-1.69,.71-3.65-.08-4.37-1.77-.71-1.69,.08-3.65,1.77-4.37,1.69-.71,3.65,.08,4.37,1.77h0Z"
      />
      <path
        id="clusterMiddle"
        :class="[{ spin }, 'spinMiddle']"
        d="M50,79.58c9.09-.02,17.64-4.37,23-11.71,.6-.89,.36-2.09-.53-2.68-.84-.56-1.97-.38-2.59,.41-7.99,10.98-23.38,13.39-34.36,5.4-6.78-4.93-10.57-12.98-10.07-21.34,.21,0,.43-.02,.63-.04,3.94-.53,6.71-4.15,6.19-8.09-.52-3.95-4.15-6.72-8.09-6.2-3.95,.52-6.72,4.15-6.2,8.09,.25,1.9,1.25,3.62,2.76,4.78,.28,.21,.57,.4,.88,.57-.06,.78-.12,1.57-.12,2.35,.02,15.71,12.75,28.45,28.46,28.46h.03ZM21.98,41.41c.4-1.21,1.46-2.09,2.73-2.25,.14-.02,.29-.03,.45-.03,1.84,0,3.33,1.51,3.32,3.35,0,1.66-1.23,3.06-2.87,3.29-.38,.05-.78,.03-1.16-.05-.11-.04-.22-.08-.34-.1-1.74-.58-2.69-2.46-2.11-4.2,0,0,0,0,0,0h0Zm54.75,22.5c3.94-.53,6.71-4.14,6.19-8.09-.35-2.59-2.06-4.79-4.49-5.75-.58-15.71-13.79-27.97-29.49-27.4-7.41,.28-14.42,3.43-19.54,8.79-.74,.78-.71,2,.06,2.74,.78,.74,2,.71,2.74-.06,9.38-9.83,24.94-10.19,34.77-.81,4.5,4.3,7.21,10.14,7.58,16.35-3.91,.71-6.51,4.45-5.8,8.37,.68,3.77,4.19,6.34,7.99,5.86h0Zm-4.26-6.69c-.24-1.83,1.04-3.5,2.87-3.74,.15-.02,.3-.03,.45-.03,1.84,0,3.33,1.5,3.33,3.34s-1.5,3.33-3.34,3.33c-1.67,0-3.08-1.24-3.31-2.9h0Z"
      />
      <path
        id="clusterOuter"
        :class="[{ spin }, 'spinOuter']"
        d="M45.62,12.24c1.45-.16,2.92-.24,4.38-.24,8.46,0,16.68,2.74,23.46,7.81-1.85,3.55-.47,7.92,3.07,9.77,3.55,1.84,7.92,.47,9.77-3.07,1.85-3.55,.47-7.92-3.07-9.77-2.25-1.18-4.95-1.09-7.11,.23-8.82-6.74-19.9-9.8-30.92-8.57-1.06,.12-1.83,1.08-1.71,2.14,.12,1.06,1.08,1.83,2.14,1.71h0Zm31.74,8.68c.1-.08,.19-.16,.27-.25,0,0,.02-.03,.02-.04,1.4-1.24,3.54-1.11,4.78,.29,1.24,1.4,1.11,3.54-.29,4.78-1.4,1.24-3.54,1.11-4.78-.29-1.14-1.28-1.14-3.21,0-4.49Zm15.65,30.2c0-6.92-1.67-13.73-4.86-19.87-.51-.94-1.68-1.3-2.62-.79-.93,.5-1.29,1.65-.81,2.58,8.38,16.1,4.59,35.85-9.16,47.71-3.07-2.52-7.61-2.08-10.13,.99-2.52,3.07-2.08,7.61,.99,10.13,1.55,1.27,3.55,1.84,5.53,1.58,3.94-.52,6.72-4.14,6.2-8.08,0,0,0,0,0,0-.06-.49-.18-.98-.35-1.44,9.66-8.15,15.23-20.15,15.21-32.79Zm-21.57,38.49c-1.83,.24-3.5-1.04-3.74-2.87-.24-1.83,1.04-3.5,2.87-3.74,.15-.02,.3-.03,.45-.03,1.84,0,3.34,1.49,3.34,3.33,0,1.68-1.24,3.09-2.9,3.31h-.02Zm-10.84-.82l-.09,.03c-12.25,3.4-25.39,.65-35.25-7.39,1.89-3.53,.56-7.92-2.97-9.81-3.53-1.89-7.92-.56-9.81,2.97-1.89,3.53-.56,7.92,2.97,9.81h0c2.24,1.2,4.95,1.14,7.14-.16,10.84,8.97,25.39,12.08,38.95,8.31,1.04-.26,1.66-1.31,1.4-2.35,0,0,0,0,0,0-.26-1.04-1.31-1.66-2.35-1.4,0,0,0,0,0,0h0Zm-38.36-10.75c0,1.84-1.49,3.33-3.33,3.33-1.84,0-3.33-1.49-3.33-3.33,0-1.84,1.5-3.33,3.33-3.33s3.33,1.5,3.33,3.33Zm-8.53-7.6c.96-.46,1.37-1.61,.92-2.58-2.49-5.23-3.77-10.95-3.76-16.75,.02-13.48,6.97-26.01,18.39-33.17,2.7,2.91,7.25,3.07,10.15,.37,1.71-1.59,2.54-3.91,2.23-6.23-.53-3.95-4.18-6.7-8.12-6.15-3.91,.54-6.66,4.13-6.16,8.05,.03,.18,.08,.34,.12,.52C14.77,22.34,7.02,36.19,7,51.12c-.02,6.36,1.4,12.65,4.14,18.4,.46,.96,1.61,1.38,2.57,.92,0,0,0,0,0,0h0ZM34.07,9.73c.14-.02,.29-.03,.45-.03,1.67,0,3.08,1.24,3.3,2.9,.24,1.83-1.04,3.5-2.86,3.75-1.31,.18-2.61-.44-3.3-1.58-.04-.12-.1-.25-.16-.37-.02-.03-.04-.05-.06-.08-.12-.27-.2-.54-.24-.83-.24-1.83,1.04-3.5,2.87-3.74h0Z"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.spin {
  animation: rotate 2s infinite linear;
  transform-origin: center;
  @media (prefers-reduced-motion) {
    animation: none;
  }
  &.spinMiddle {
    animation-name: rotateCounter;
    animation-duration: 4s;
  }
  &.spinOuter {
    animation-duration: 6s;
  }
}

@keyframes rotate {
  from {
    transform: rotate3d(0, 0, 1, 0deg);
  }

  to {
    transform: rotate3d(0, 0, 1, 359deg);
  }
}
@keyframes rotateCounter {
  from {
    transform: rotate3d(0, 0, 1, 359deg);
  }

  to {
    transform: rotate3d(0, 0, 1, 0);
  }
}
</style>
